import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import SEO from '../SEO';
import DistributorsHero from './DistributorsHero';
import BillingSection from './BillingSection';
import ResellerSection from './ResellerSection';
import RevenueSection from './RevenueSection';
import QuotingSection from './QuotingSection';
import FutureProofSection from './FutureProofSection';
import TestimonialSection from './TestimonialSection';
import DistributorsFAQ from './DistributorsFAQ';
import CTA from '../CTA';

const ITDistributorsPage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Distribuidores IT · Plataforma para mayoristas y distribuidores cloud"
        description="Automatiza operación, facturación y canal de revendedores. Cotizador con IA, márgenes auditables, onboarding rápido y marketplace white-label para tu red."
        keywords="distribuidores IT, mayoristas cloud, canal IT, reseller management, CSP distribution"
        canonical="/distribuidores-it"
      />
      <Navbar />
      <DistributorsHero />
      <BillingSection />
      <ResellerSection />
      <RevenueSection />
      <QuotingSection />
      <FutureProofSection />
      <TestimonialSection />
      <DistributorsFAQ />
      <CTA />
      <Footer />
    </div>
  );
};

export default ITDistributorsPage;
